import React from 'react';

export default function ConfirmModal({ title, message, onConfirm, onCancel, confirmLabel = 'Confirmar', danger = false }) {
  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div style={styles.modal}>
        <div style={styles.iconWrap}>
          <span style={styles.icon}>{danger ? '⚠️' : '❓'}</span>
        </div>
        <h3 style={styles.title}>{title}</h3>
        <p style={styles.message}>{message}</p>
        <div style={styles.footer}>
          <button style={styles.btnCancel} onClick={onCancel}>Cancelar</button>
          <button
            style={{ ...styles.btnConfirm, ...(danger ? styles.btnDanger : styles.btnPrimary) }}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1001, padding: '20px',
  },
  modal: {
    background: '#fff',
    borderRadius: '14px',
    padding: '32px 28px',
    width: '100%', maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0 25px 50px rgba(0,0,0,0.2)',
  },
  iconWrap: { fontSize: '40px', marginBottom: '16px' },
  icon: {},
  title: { fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '10px' },
  message: { fontSize: '14px', color: '#6b7280', lineHeight: 1.6, marginBottom: '24px' },
  footer: { display: 'flex', gap: '10px', justifyContent: 'center' },
  btnCancel: {
    padding: '9px 20px', background: '#f9fafb',
    border: '1px solid #e5e7eb', borderRadius: '7px',
    fontSize: '14px', cursor: 'pointer', fontFamily: 'inherit',
  },
  btnConfirm: {
    padding: '9px 20px', border: 'none', borderRadius: '7px',
    fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit',
    color: '#fff',
  },
  btnDanger: { background: '#dc2626' },
  btnPrimary: { background: '#1e40af' },
};
